import AlephBet from "alephbet"
import {storage_adapter, lamed_adapter} from "./adapters"
import {on_registration_page, not_logged_in} from "./helpers"
import {registered_successfully} from "./goals"
import $ from "cash-dom"

export default () => {
  const subtitle_variants_v2 = new AlephBet.Experiment({
    name: "202506 Subtitle variants v2",
    tracking_adapter: lamed_adapter,
    storage_adapter: storage_adapter,
    trigger: () => (on_registration_page() && not_logged_in()),
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Variant": {
        activate: (experiment) => {
          if (!experiment.options.trigger()) return

          $(".headline h2").remove()
          $("body.registrations .l-hero").css("padding", "40px 0")
          $(".headline, h1").css("margin", "0")
        }
      }
    }
  })

  subtitle_variants_v2.add_goals([
    registered_successfully
  ])
}
